import React from 'react';
import styled from 'styled-components';
import { Box } from 'rebass/styled-components';
import theme from 'styled-theming';

const color = theme('mode', {
  light: (props) => props.theme.colors.ghost,
  dark: (props) => props.theme.colors.ghost,
});

const DividerItem = styled(Box)`
  border-right: 1px solid ${color};
  height: 36px;
  margin: 0 40px;
`;

function Divider() {
  return <DividerItem />;
}

export default Divider;
